{
    "NAME": "Elenco dei log delle modifiche di configurazioneLingua",
    "ConfigChangeLogList_Column_Description": "Descrizione",
    "ConfigChangeLogList_Column_DateTime": "Data\/Ora",
    "ConfigChangeLogList_Column_User": "Utente",
    "ConfigChangeLogList_Column_Action": "Azione",
    "ConfigChangeLogList_Column_Type": "Tipo",
    "ConfigChangeLogList_Column_CME": "Formazione continua in medicina (CME)",
    "ConfigChangeLogList_Column_TelSys": "Server di telefonia",
    "ConfigChangeLogList_Column_Partition": "Partizione",
    "ConfigChangeLogList_Filter_Before": "Prima",
    "ConfigChangeLogList_Filter_Actions": "Azioni",
    "ConfigChangeLogList_Filter_EntityTypes": "Tipi di entità",
    "ConfigChangeLogList_Filter_MultiSelectedCount": "[{} selezionato]",
    "ConfigChangeLogList_Filter_SearchUsername": "Cerca nome utente",
    "ConfigChangeLogList_Filter_SuppressNulls": "Sopprimi i valori nulli",
    "ConfigChangeLogList_Filter_SuppressNulls_No": "NO",
    "ConfigChangeLogList_Filter_SuppressNulls_Yes": "SÌ",
    "ConfigChangeLogList_Filter_ActionDescription_All": "[Tutto]",
    "ConfigChangeLogList_Filter_ActionDescription_INSERT": "Inserire",
    "ConfigChangeLogList_Filter_ActionDescription_UPDATE": "Aggiornamento",
    "ConfigChangeLogList_Filter_ActionDescription_DELETE": "Eliminare",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN": "Login",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_FAILED": "Accesso non riuscito",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_AS": "Accedi come",
    "ConfigChangeLogList_Filter_ActionDescription_SYNC_REQUESTED": "Sincronizzazione richiesta",
    "ConfigChangeLogList_Filter_TypeDescription_All": "[Tutto]",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgents": "agenti ACD",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgentsOwned": "Agenti ACD di proprietà (iscrizioni)",
    "ConfigChangeLogList_Filter_TypeDescription_Devices": "Dispositivi",
    "ConfigChangeLogList_Filter_TypeDescription_DevicesOwned": "Dispositivi posseduti (abbonamenti)",
    "ConfigChangeLogList_Filter_TypeDescription_DNISAssociations": "Associazioni DNS",
    "ConfigChangeLogList_Filter_TypeDescription_Codes": "Codici",
    "ConfigChangeLogList_Filter_TypeDescription_CallRecordingIntegrations": "Integrazioni per la registrazione delle chiamate",
    "ConfigChangeLogList_Filter_TypeDescription_Partitions": "Pareti divisorie",
    "ConfigChangeLogList_Filter_TypeDescription_TelephoneSystems": "sistemi di denominazione",
    "ConfigChangeLogList_Filter_TypeDescription_Users": "Utenti",
    "ConfigChangeLogList_Filter_TypeDescription_CRMConfiguration": "Configurazione CRM",
    "ConfigChangeLogList_Detail_Title": "Voce del registro di controllo",
    "ConfigChangeLogList_Detail_SummaryColumnItem": "Articolo",
    "ConfigChangeLogList_Detail_SummaryColumnValue": "Valore",
    "ConfigChangeLogList_Detail_Field": "Campo",
    "ConfigChangeLogList_Detail_OldValue": "vecchio valore",
    "ConfigChangeLogList_Detail_NewValue": "Nuovo valore"
}